// Formato numérico con separador de miles (es-MX): 12,345 / 1,234.5
//
// Helper único para todas las pestañas del dashboard. Las cifras enteras
// (conteos de llamadas, ventas, etc.) deben pasar por aquí para mostrar el
// separador de miles. El dinero tiene su propio formateador (2 decimales) y
// los porcentajes se siguen formateando aparte.

const _cache = {};

function _fmt(decimals) {
  const key = decimals == null ? 'def' : String(decimals);
  if (!_cache[key]) {
    _cache[key] = new Intl.NumberFormat(
      'es-MX',
      decimals == null
        ? {} // default: agrupa miles, hasta 3 decimales naturales
        : { minimumFractionDigits: decimals, maximumFractionDigits: decimals },
    );
  }
  return _cache[key];
}

/**
 * Formatea un número con separador de miles es-MX.
 * @param {number|string|null|undefined} n
 * @param {number} [decimals] fija la cantidad de decimales (opcional).
 * @param {string} [fallback='—'] valor a mostrar si n no es numérico.
 * @returns {string}
 */
export function formatNumber(n, decimals, fallback = '—') {
  if (n === null || n === undefined || n === '') return fallback;
  const num = Number(n);
  if (Number.isNaN(num)) return fallback;
  return _fmt(decimals).format(num);
}

export default formatNumber;
